import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ICategoryContext, CategoryContext } from '../../../categoryState/categoryContext';
import { categoryTypes } from 'appConstants';
import { Select } from 'antd';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CategoryTypeSelect.module.scss';

const { Option } = Select;

const CategoryTypeSelect: React.FC = () => {
	const { setIDsSelectedCategoryTypes, IDsSelectedCategoryTypes } = useContext<ICategoryContext>(CategoryContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { t } = useTranslation('listing');

	return (
		<div className={style.container} data-test="CategoryTypeSelect">
			<Text translationNameSpace="listing" translationKey="categoryTypeLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDsSelectedCategoryTypes}
				value={IDsSelectedCategoryTypes}
				mode="multiple"
				showArrow={true}
				allowClear={true}
				showSearch={false}
				removeIcon={false}
				menuItemSelectedIcon={null}
				listItemHeight={categoryTypes.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				<>
					<Option className={style.disabledItem} value="empty" disabled={true}>
						<Text
							translationNameSpace="listing"
							translationKey="selectAnyItemPlaceholder"
							asFragment={true}
						/>
					</Option>
					{categoryTypes.map((el) => (
						<Option className={style.listItem} value={el.categoryID} key={el.categoryID}>
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#${el.categoryName}`} />
							</svg>
							<Text translationNameSpace="listing" translationKey={el.categoryName} asFragment={true} />
						</Option>
					))}
				</>
			</Select>
		</div>
	);
};

export default CategoryTypeSelect;
